import React from 'react';
import ReactDOM from 'react-dom/client';
// 
// Design tokens (CSS variables only) and the cx-* component classes the Projects
// screens use. Both only add names; nothing here restyles existing markup.
import './styles/tokens.css';
import './index.css';
import './styles/dashboard.css';
import './styles/kit.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
